import { call, all, takeLatest, put } from 'redux-saga/effects';
import { ILoginPayload, login, logout, fetchUser } from './user.actions';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import getDataFromResponse from '../utils/get-data-from-res';
import { setCookie, removeCookie, getCookie } from '../utils/cookie';

function* loginUserFromResponse(res: any) {
    setCookie('_s', getDataFromResponse(res), 1);
    let data = { data: getDataFromResponse(res) };
    let tempUser = yield getUserAsync(data);
    const user = getDataFromResponse(tempUser);
    yield put(
        login({
            user,
        })
    );
}

function* loginAsync({ payload: { data } }: { payload: ILoginPayload }) {
    const res = yield getFetchInstance().post('login', data);
    yield loginUserFromResponse(res);
}

function* getUserAsync(data: { data: string }) {
    const res = yield getFetchInstance().post('data', data);
    return res;
}

function* logoutAsync() {
    yield getFetchInstance().post('logout');
    removeCookie('_s');
    yield put(logout());
}

function* loadUserAsync() {
    let res = yield getUserAsync({ data: getCookie('_s') });
    const user = getDataFromResponse(res);
    yield put(
        fetchUser({
            user,
        })
    );
}

function* watchLogin() {
    yield takeLatest(
        createFetchSagaPattern('LOGIN'),
        createFetchFunction('LOGIN', loginAsync)
    );
}

function* watchLogout() {
    yield takeLatest(
        createFetchSagaPattern('LOGOUT'),
        createFetchFunction('LOGOUT', logoutAsync)
    );
}

function* watchFetchUser() {
    yield takeLatest(
        createFetchSagaPattern('CHECK_USER'),
        createFetchFunction('CHECK_USER', loadUserAsync)
    );
}

export default function* userSagas() {
    yield all([call(watchLogin), call(watchLogout), call(watchFetchUser)]);
}
